// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__3t53Z","arrow":"style_arrow__HUSMW"};